// Mobilni izbornik 4d.wand (donji panel ispod lg breakpointa).

const supportsScrollTimeline = () => window.CSS?.supports('animation-timeline: scroll()');

// Maske na rubovima popisa modula prate položaj pomicanja. Preglednici sa scroll-driven
// animacijama to rade u CSS-u; ostalima (npr. Firefox) ovaj kod postavlja iste vrijednosti:
// maska raste kroz prvih i nestaje kroz zadnjih --fade piksela.
function initScrollMasks(list) {
    if (supportsScrollTimeline()) {
        return;
    }

    let frame = 0;
    const update = () => {
        frame = 0;
        const fade = parseFloat(getComputedStyle(list).getPropertyValue('--fade')) || 0;
        const remaining = Math.max(list.scrollHeight - list.clientHeight - list.scrollTop, 0);
        list.style.setProperty('--fade-top', `${Math.min(list.scrollTop, fade)}px`);
        list.style.setProperty('--fade-bottom', `${Math.min(remaining, fade)}px`);
    };
    const schedule = () => {
        frame ||= requestAnimationFrame(update);
    };

    list.addEventListener('scroll', schedule, {passive: true});
    // Otvaranje izbornika, rotacija i promjena breakpointa mijenjaju visinu popisa
    new ResizeObserver(schedule).observe(list);
}

// Panel je u okomitom scrolleru sa snap točkama „zatvoreno” (vrh) i „otvoreno” (dno), pa ga dodir
// zatvara običnim pomicanjem prema dolje, sa zamahom preglednika. Otvaranje i svi drugi načini
// zatvaranja (gumb, Escape, dodir iznad panela) samo pomiču scroller; IntersectionObserver skriva
// popover tek kad panel izađe iz prozora, pa je zatvaranje uvijek animirano.
function initSheet(menu) {
    const scroller = menu.querySelector('.mega-menu__scroller');
    const sheet = menu.querySelector('.mega-menu__sheet');
    const handle = menu.querySelector('.mega-menu__header');
    const mobile = window.matchMedia('(width < 1200px)');
    const isOpen = () => menu.matches(':popover-open');
    const openSheet = () => scroller.scrollTo({top: scroller.scrollHeight, behavior: 'auto'});
    const closeSheet = () => scroller.scrollTo({top: 0, behavior: 'auto'});

    // Desktop koristi popover="auto" (zatvaranje klikom izvan i Escapeom). Mobilni panel je
    // "manual": preglednikovo zatvaranje bi ga uklonilo bez animacije i usred povlačenja.
    const syncMode = () => {
        if (isOpen()) {
            menu.hidePopover();
        }
        menu.popover = mobile.matches ? 'manual' : 'auto';
    };
    syncMode();
    mobile.addEventListener('change', syncMode);

    // Popover se otvara gumbom (popovertarget) sa scrollerom na vrhu, pa ga pomicanje uvlači
    menu.addEventListener('toggle', (event) => {
        if (event.newState === 'open' && mobile.matches) {
            openSheet();
        }
    });

    const visible = 1 / window.innerHeight;
    new IntersectionObserver((entries) => {
        if (mobile.matches && isOpen() && entries.at(-1).intersectionRatio < visible) {
            menu.hidePopover();
        }
    }, {root: menu, threshold: [visible, 1]}).observe(sheet);

    menu.querySelector('.mega-menu__close').addEventListener('click', (event) => {
        if (mobile.matches) {
            event.preventDefault();
            closeSheet();
        }
    });

    // Dodir na zatamnjeni dio iznad panela
    menu.addEventListener('click', (event) => {
        if (mobile.matches && !sheet.contains(event.target)) {
            closeSheet();
        }
    });

    document.addEventListener('keydown', (event) => {
        if (event.key === 'Escape' && mobile.matches && isOpen()) {
            event.preventDefault();
            closeSheet();
        }
    });

    if (!supportsScrollTimeline()) {
        scroller.addEventListener('scroll', () => {
            const range = scroller.scrollHeight - scroller.clientHeight;
            scroller.style.backgroundColor = `rgb(17 24 39 / ${range > 0 ? 55 * scroller.scrollTop / range : 0}%)`;
        }, {passive: true});
    }

    // Mišem se scroller ne može povući, pa zaglavlje služi kao ručka koja ga pomiče. Snap je za
    // vrijeme povlačenja isključen i vraća se kad panel stigne do otvorenog ili zatvorenog položaja.
    handle.setAttribute('data-drag-handle', '');
    let drag = null;

    const restoreSnap = () => {
        scroller.style.removeProperty('scroll-snap-type');
    };

    handle.addEventListener('pointerdown', (event) => {
        if (!mobile.matches || event.pointerType !== 'mouse' || event.button !== 0 || event.target.closest('a, button')) {
            return;
        }
        drag = {startY: event.clientY, startTop: scroller.scrollTop, y: event.clientY, time: event.timeStamp, velocity: 0, active: false};
        handle.setPointerCapture(event.pointerId);
    });

    handle.addEventListener('pointermove', (event) => {
        if (!drag || !handle.hasPointerCapture(event.pointerId)) {
            return;
        }
        const offset = event.clientY - drag.startY;
        // Mali pomak još je klik, ne povlačenje
        if (!drag.active) {
            if (Math.abs(offset) < 4) {
                return;
            }
            drag.active = true;
            handle.setAttribute('data-dragging', '');
            scroller.style.scrollSnapType = 'none';
            scroller.style.scrollBehavior = 'auto';
        }
        drag.velocity = (event.clientY - drag.y) / Math.max(event.timeStamp - drag.time, 1);
        drag.y = event.clientY;
        drag.time = event.timeStamp;
        scroller.scrollTop = drag.startTop - offset;
    });

    handle.addEventListener('lostpointercapture', () => {
        const ended = drag;
        drag = null;
        if (!ended?.active) {
            return;
        }
        handle.removeAttribute('data-dragging');
        scroller.style.removeProperty('scroll-behavior');
        const pulled = scroller.scrollHeight - scroller.clientHeight - scroller.scrollTop;
        // Zatvara nakon četvrtine visine panela ili brzog zamaha prema dolje
        (pulled > sheet.offsetHeight / 4 || ended.velocity > 0.5 ? closeSheet : openSheet)();
        scroller.addEventListener('scrollend', restoreSnap, {once: true});
        setTimeout(restoreSnap, 800);
    });
}

document.addEventListener('DOMContentLoaded', () => {
    const menu = document.querySelector('.mega-menu');
    if (!menu) {
        return;
    }
    initScrollMasks(menu.querySelector('.mega-menu__modules'));
    initSheet(menu);
});
